import { render, staticRenderFns } from "./JJTooltip.vue?vue&type=template&id=6aa64e41&scoped=true&"
import script from "./JJTooltip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./JJTooltip.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./JJTooltip.vue?vue&type=style&index=0&id=6aa64e41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa64e41",
  null
  
)

export default component.exports